import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { checkBrowserSupport, showUnsupportedBrowserMessage } from './browserSupport';
import { objectFitPolyfill } from './objectFitPolyfill';
import { iniciarAnalytics } from './lib/analytics';

// Inicializar polyfill para object-fit em navegadores antigos
objectFitPolyfill();

// Analytics. Sem REACT_APP_POSTHOG_KEY no ambiente, iniciarAnalytics() é no-op — o app
// funciona igual e NENHUM byte sai. É assim que isto vai pra produção desligado, e só
// liga quando a chave for configurada, de propósito. Ver src/lib/analytics.js.
iniciarAnalytics();

// Verificar compatibilidade do navegador antes de renderizar
try {
  const isSupported = checkBrowserSupport();
  
  if (isSupported) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    reportWebVitals();
  } else {
    showUnsupportedBrowserMessage();
  }
} catch (error) {
  console.error('Erro ao inicializar a aplicação:', error);
  showUnsupportedBrowserMessage();
}
